import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilesCoreService } from './files-core.service';
import { FileSelectorComponent } from './file-selector/file-selector.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [FileSelectorComponent],
  imports: [CommonModule, SharedModule, ReactiveFormsModule],
  providers: [FilesCoreService],
  exports: [FileSelectorComponent],
})
export class FilesCoreModule {}
